module.exports = __webpack_public_path__ + "img/1.21917398.png";